import React from 'react';
import MyAppointment from './MyAppointment';

const Dashboard = () => {
    return (
        <div>
            <MyAppointment></MyAppointment>
        </div>
    );
};

export default Dashboard;